import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {},
  state: {
    siderCollapsed: false,
    user: {
      email: 'mock'
    },
    filtros: {
      tipo: '',
      selectedGroup: true,
      datas: [],
      datas2: [],
      grupo: '',
      comparativo: 'TerceiroQuartil',
      shortcut: '', // short para datas selecionadas
    },
    dreFiltros: {},
    fluxoDeCaixaFiltros: {},
    acessos: []
  },
  mutations: {
    updateSiderCollapse(state, isShow) {
      state.siderCollapsed = isShow;
    },
    updateFiltros(state, updated) {
      state.filtros = updated;
    },
    updateUser(state, userData) {
      state.user = userData;
    },
    updateDREFiltros(state, updated) {
      state.dreFiltros = updated;
    },
    updateFluxoDeCaixaFiltros(state, updated) {
      state.fluxoDeCaixaFiltros = updated;
    },
    setAcessosUser(state, playload) {
      state.acessos = playload;
    }
  },
  actions: {
    updateSiderCollapse(context, data) {
      context.commit('updateSiderCollapse', data);
    },
    updateFiltros(context, data) {
      context.commit('updateFiltros', data);
    },
    updateUser(context, data) {
      context.commit('updateUser', data);
    },
    updateDREFiltros(context, data) {
      context.commit('updateDREFiltros', data);
    },
    updateFluxoDeCaixaFiltros(context, data) {
      context.commit('updateFluxoDeCaixaFiltros', data);
    }
  },
  getters: {
    siderCollapsed: state => state.siderCollapsed,
    filtros: state => state.filtros,
    user: state => state.user,
    dreFiltros: state => state.dreFiltros,
    fluxoDeCaixaFiltros: state => state.fluxoDeCaixaFiltros,
  }
});
